function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgSidebarSecurity(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    "uc-svg": "www"
  }, props), React.createElement("g", {
    fill: "#0A1633",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M9.408 7.46a.755.755 0 00-.204.652l.207 1.256-1.083-.592a.68.68 0 00-.659 0l-1.083.593.207-1.256a.754.754 0 00-.203-.652l-.877-.89 1.21-.184a.715.715 0 00.534-.403L8 4.841l.541 1.142a.71.71 0 00.533.404l1.211.183-.876.89zm1.985-1.96l-1.907-.288-.854-1.8A.7.7 0 007.999 3a.7.7 0 00-.633.412l-.854 1.8-1.907.288c-.387.06-.654.434-.597.837.022.16.094.307.205.42l1.38 1.401-.326 1.979c-.067.4.19.782.575.852a.682.682 0 00.454-.076L8 9.978l1.705.933a.692.692 0 00.956-.3.763.763 0 00.073-.476l-.326-1.978 1.38-1.402a.759.759 0 00.011-1.042.698.698 0 00-.406-.214V5.5z"
  }), React.createElement("path", {
    d: "M13.497 8.422c-.696 2.977-2.553 5.115-5.525 6.359C5 13.537 3.144 11.399 2.45 8.42a11.537 11.537 0 01-.213-3.82C3.5 4.474 4.192 3.327 4.464 2.477L7.972 1.21l3.508 1.27c.27.85.964 2 2.228 2.124.142 1.276.07 2.567-.213 3.818h.002zm1.28-4.545a.58.58 0 00-.644-.466c-1.223.16-1.588-1.45-1.602-1.516a.59.59 0 00-.375-.436L8.206.034a.574.574 0 00-.234-.032.574.574 0 00-.234.032L3.79 1.459a.59.59 0 00-.375.436c-.014.069-.366 1.68-1.602 1.52a.582.582 0 00-.646.462c-.018.09-.446 2.218.138 4.773.548 2.379 2.098 5.578 6.414 7.31.067.026.14.04.212.04h.078a.583.583 0 00.212-.04c4.314-1.732 5.866-4.931 6.413-7.31.585-2.555.157-4.684.142-4.773z"
  })));
}

SvgSidebarSecurity.clsName = 'icon-www__sidebar_security';
SvgSidebarSecurity.remarkName = 'unknown';
export default SvgSidebarSecurity;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/SidebarSecurity.js
// module id = 2434
// module chunks = 17 18